var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProfile1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3212 9.35785C31.6819 7.62242 29.4327 6.66663 26.9872 6.66663C25.1593 6.66663 23.4853 7.23073 22.0115 8.34313C21.2679 8.90458 20.594 9.59161 20 10.3933C19.4061 9.59179 18.7321 8.90458 17.9882 8.34313C16.5146 7.23073 14.8406 6.66663 13.0127 6.66663C10.5672 6.66663 8.31774 7.62242 6.6785 9.35785C5.05886 11.073 4.16663 13.4162 4.16663 15.956C4.16663 18.5701 5.16468 20.963 7.30738 23.4868C9.2242 25.7444 11.9791 28.0361 15.1694 30.6899C16.2588 31.5961 17.4937 32.6234 18.7758 33.7176C19.1146 34.0072 19.5496 34.1668 20 34.1666C20.4505 34.1666 20.8854 34.0072 21.2236 33.7181C22.5058 32.6236 23.7413 31.5959 24.8312 30.6891C28.021 28.0358 30.7759 25.7444 32.6928 23.4866C34.8355 20.9631 35.8333 18.5701 35.8333 15.9557C35.8333 13.4162 34.9411 11.073 33.3212 9.35785Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile1);
export default __webpack_public_path__ + "static/media/icon-profile_1.20a8149efad3280a35f019ba951f73ae.svg";
export { ForwardRef as ReactComponent };